<template>
	<div id="app">
		<NavBar />
			<b-container v-if="coming" fluid class="bv-example-row px-0 padding-top-mobile" id="project-images" style="background-color: #d0201f">
				<b-overlay :show="$store.state.loading" rounded="sm">
					<b-row class="align-items-center proyect-elements" style="background-color: #d0201f" no-gutters v-for="(data, key) in coming" v-bind:key="'coming-'+key" data-aos="fade-down" data-aos-offset="200">
						<b-col md="8" data-aos="fade-down" data-aos-offset="200" :order-md="(data.left_right ? '1' : '2')">
							<b-img class="d-block img-fluid w-100" :src="data.image_url" alt="image" />
						</b-col>
						<b-col md="4" class="text-left comming-elem-data text-white" data-aos="fade-up"  data-aos-offset="200" :order-md="(data.left_right ? '2' : '1')">
							<h2 class="coming-subtitle-type">{{data.type}}</h2>
							<h2 class="coming-subtitle">{{data.title}}</h2>
							<b-button variant="outline-light" type="button" class="mt-5" v-if="true == false">Solicita más información</b-button>
						</b-col>
					</b-row>
				</b-overlay>
			</b-container>
	</div>
</template>
<script>
	import NavBar from '../../../components/NavBar.vue';
	export default {
		name: 'project',
		components: {
			NavBar
		},
		data(){
			return{
				coming: []
			}
		},
		mounted() {
			this.$store.commit('setComings');

			this.$root.captureUtm();
			this.$root.sessionStorageSet('utm_dhunter','inmobiliariabi');
		},
		watch: {
			'$store.state.loading': {
				handler: function()  {
					if(!this.$store.state.loading){
						this.coming = this.$store.getters.getComings;
					}
				}
			}
		}
	}
</script>
<style>
	.coming-subtitle-type {
		font-size: 2rem;
		line-height: 2rem;
		font-weight: bold;
	}
	.coming-subtitle {
		font-size: 1.5rem;
		line-height: 1.5rem;
		text-transform: uppercase;
	}
	.coming-subtitle-location {
		font-size: 3rem;
		line-height: 3rem;
		text-transform: uppercase;
		font-weight: bold;
	}
	.text-red{
		color: #b12525 !important;
		text-transform: uppercase;
		font-weight: bold;
	}
	.comming-elem-data{
		padding-left: 3rem !important;
	}
	@media (max-width: 800px){
		.coming-subtitle-type{
			font-size: 1.5rem;
			font-size: 1.5rem;
		}
		.coming-subtitle{
			font-size: 1rem;
			line-height: 1rem;
		}
		.padding-top-mobile{
			padding-top: 118px;
		}
		.project-header h3{
			font-size: 1rem;
			line-height: 1rem;
		}
		.project-header{
			padding-top: 100px;
		}
		.header-project{
			height: 100vh;
		}
		.comming-elem-data{
			padding-left: 1.5rem !important;
		}
		.lead{
			font-size: 1rem !important;
		}
		.details{
			padding-left: 15px !important;
			padding-right: 15px !important;
		}
	}
</style>
